import widget from './widget';
import settings from './settings';

export default {
  widget,
  settings,
  name: 'Box Count chart',
  description: 'Displays count'
};



// WEBPACK FOOTER //
// ./app/widgets.new/BoxCountChart/index.js